export default __webpack_public_path__ + "static/media/Logo(Light).f52bb473.png";